import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderOnly'
})
export class OrderOnlyPipe implements PipeTransform {

  transform(arr: any): any {
    return arr.filter((arr: any) =>{
      return arr.orderto == 1
    })
}

}
